import {
	Dialog,
	DialogContent,
	Grid,
	Typography,
	IconButton as MaterialIconButton,
	Button,
} from '@mui/material';
import { CloseIcon } from '../assets/icons/Icons';
import IconButton from './IconButton';

function PopupDialog({
	isModalOpen,
	onClose,
	onClickBtn,
	children,
	title,
	btnTitle,
}) {
	return (
		<>
			<Dialog
				fullWidth
				maxWidth="sm"
				open={isModalOpen}
				onClose={onClose}
				scroll="body">
				<DialogContent style={{ padding: '0px 0px 20px 0px' }}>
					<Grid
						container
						sx={{ boxShadow: 3 }}
						padding={'10px'}
						flexDirection={'row'}
						justifyContent={'space-between'}
						alignItems={'center'}>
						<Typography fontWeight={'600'}>{title}</Typography>
						<MaterialIconButton
							style={{ padding: '0' }}
							onClick={onClose}>
							<CloseIcon />
						</MaterialIconButton>
					</Grid>
					<Grid container padding={'10px'}>
						{children}
					</Grid>
					<Grid
						container
						justifyContent={'flex-end'}
						paddingTop={'10px'}
						paddingRight={'15px'}>
						<Button
							onClick={onClose}
							sx={{
								border: '2px solid #28696D',
								paddingLeft: '15px',
								paddingRight: '15px',
								color: '#28696D',
								textTransform: 'none',
								marginRight: '10px',
							}}>
							{'Cancel'}
						</Button>
						<IconButton text={'AddUser'} onClick={onClickBtn} />
					</Grid>
				</DialogContent>
			</Dialog>
		</>
	);
}

export default PopupDialog;
